/**
 * BuildRefBadge — always-visible-but-unobtrusive deployed-build reference.
 *
 * WHY (FR-FE-BUG-TOOL-EXPAND-DIAGNOSTICS-AND-VERSION-REF-2026-06-01):
 * Cloud Run builds here are non-hermetic — one git commit can produce several
 * distinct images, and the Cloud Run commit-sha label collides across them, so
 * we cannot otherwise tell which deployed revision a user is on. Surfacing the
 * Cloud Build id (+ build time on hover/title) gives support a reliable string
 * the operator can read back, matching the same ref carried in the bug-report
 * payload (see buildInfo.ts + debugReportCapture.ts).
 *
 * Placement: fixed bottom-left, muted + tiny, pointer-events-none so it never
 * intercepts clicks. The full build/commit/time triple is in the `title`
 * tooltip for copy-on-hover without taking screen space.
 */
import { getBuildInfo, formatBuildRef } from './buildInfo'

export function BuildRefBadge() {
  const info = getBuildInfo()
  const ref = formatBuildRef(info)
  const title = `build: ${info.build}\ncommit: ${info.commit}\nbuilt: ${info.builtAt}`
  return (
    <div
      className="pointer-events-none fixed bottom-1 left-1 z-10 select-none font-mono text-[10px] leading-none text-muted-foreground/50"
      title={title}
      aria-hidden="true"
      data-testid="build-ref-badge"
    >
      {ref}
    </div>
  )
}
